module.exports = __webpack_public_path__ + "static/customer-testimonial-bg-4-mobile-6af24b70ed82771eda15eab534cc24ef.png";